import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup} from "@angular/forms";
import {EditCustomerAddressData} from "@biletix/core/models/customer/edit-customer-address-data.model";
import {CustomerAddressInput} from "@biletix/core/models/customer/customer-address-input.model";
import {CustomerAccountService} from "@biletix/core/services/customer-account.service";
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";


@Component({
  selector: 'btx-edit-customer-address',
  templateUrl: './edit-customer-address.component.html',
  styleUrls: ['./edit-customer-address.component.scss'],
  standalone: false
})
export class EditCustomerAddressComponent extends AbstractionComponent implements OnInit {


  parentFormGroup: FormGroup | any;
  isSameInvoiceAddressWithDeliveryAddress: boolean = false;
  isInvoiceAddress: boolean = false;
  isDeliveryAddress: boolean = true;//isDeliveryAddress=true ise teslimat adresi değilse fatura adresi

  constructor(private dialogRef: MatDialogRef<EditCustomerAddressComponent>,
              @Inject(MAT_DIALOG_DATA) public  data: EditCustomerAddressData,
              private customerAccountService: CustomerAccountService,
              private fb: FormBuilder) {
    super();

    this.isDeliveryAddress = data.isDeliveryAddress;
    if (data.editMode) {
      if (data.address.invoiceAddress) {
        this.isInvoiceAddress = true;
      }
    }
  }

  ngOnInit(): void {
    this.initializeAddressForm();
  }


  setSameInvoiceAddressWithDeliveryAddress(checked: boolean) {
    this.isSameInvoiceAddressWithDeliveryAddress = checked;
    this.isInvoiceAddress = checked;
  }

  initializeAddressForm() {
    this.parentFormGroup = this.fb.group({});
  }


  get modalTitle() {
    let title = this.isDeliveryAddress ? 'shared.info.addNewAddress' : 'shared.info.addNewBillingAddress';
    if (this.data.editMode) {
      title = this.isDeliveryAddress ? 'shared.info.editAddress' : 'shared.info.editBillingAddress';
    }
    return title;
  }


  saveOrUpdateAddress() {

    if (this.parentFormGroup.invalid) {
      this.parentFormGroup.markAllAsTouched();
      return;
    }


    let formValue = this.parentFormGroup.value;
    let addressInput: CustomerAddressInput = formValue.addressInfo;
    addressInput.deliveryAddress = this.isDeliveryAddress;
    addressInput.invoiceAddress = this.isInvoiceAddress;
    //
    let invoiceInfo = formValue.invoiceInfo;
    if (invoiceInfo) {
      addressInput.companyAddress = invoiceInfo.companyAddress;//Biresel mi Kurumsal mı
      addressInput.taxNo = invoiceInfo.taxNo;
      addressInput.companyTitle = invoiceInfo.companyTitle;
      addressInput.taxOffice = invoiceInfo.taxOffice;
      addressInput.invoiceAddress = true;
    }

    //
    this.customerAccountService
      .saveOrUpdateCustomerAddress(addressInput)
      .pipe(this.takeUntilDestroy())
      .subscribe(customerAddress => {
          if (customerAddress) {
            this.dialogRef.close(customerAddress);
          }
        }
      );
  }

}
